import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChatModernWindow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 80 80",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M57 57h9v2H14v-2h9V23a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2v34zM26 29a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V30a1 1 0 0 0-1-1H26z",
		fillRule: "evenodd"
	})
});
export default SvgChatModernWindow;
